<script>
    import { onMount } from 'svelte'
    // import obsStudioPng from '../statics/obs-studio.png'
    // import obsIcon from '../statics/obs-icon.svg'
    let dragged
    let pos = 50
    let source
    export let id
    export let width
    export let height
    export let name
    export let url
    export let key

    onMount(() => {
        source = document.querySelector(`#${id}`)
        const image = document.createElement('img')
        image.src = './images/obs-icon.svg'
        // image.style.width = '50px'
        // image.style.height = '50px'
        // image.className = 'ghost'
        const div = document.createElement('div')
        div.appendChild(image)
        div.style.position = 'absolute'
        // div.style.top = 'px'
        // div.style.left = '30px'

        source.addEventListener('dragstart', (e) => {
            dragged = e.target
            e.dataTransfer.setDragImage(image, pos, pos)
            e.dataTransfer.setData('text/uri-list', dragged.href)
        })

        // Optionally, remove the focus from the button
        source.addEventListener('dragend', (e) => dragged.blur())

        // If using an anchor, block the default behaviour
        source.addEventListener('click', (e) => e.preventDefault())
    })
</script>

<a
    title="Drag into OBS"
    {id}
    href={`${url}/${key}?layer-name=${name}&layer-height=${height}&layer-width=${width}`}
    draggable="true"
    class="-ml-px relative inline-flex items-center px-2 pr-1 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-r-md text-gray-700 bg-gray-50 hover:text-gray-500 hover:bg-white focus:outline-none transition ease-in-out duration-150">
    <img
        class="ghost mr-1"
        alt="Open Broadcast Software Studio Icon"
        src={'./images/obs-icon.svg'}
        width="20"
        height="20" />
</a>

<style>
    .ghost {
        pointer-events: none;
        color: white;
    }
</style>
